// The upload limit is a transport guard, not a FEMA figure. It equals the server's multer limit
// (Fusion-Backend `fema.config.ts` audio `max-bytes`, 4 MiB).
export const IPAWS_EAS_AUDIO_MAXIMUM_BYTES = 4 * 1024 * 1024;
// The FEMA rule: IDG v4.06 Table 81 p79 — broadcast content over two minutes of playing time may be
// truncated. The server refuses the same limit (`max-duration-seconds`, 120).
export const IPAWS_EAS_AUDIO_MAXIMUM_DURATION_SECONDS = 2 * 60;
export const IPAWS_EAS_AUDIO_DURATION_ERROR =
  'The MP3 file must be 2 minutes or shorter. EAS broadcast content is two minutes at most (IDG v4.06 Table 81 p79).';
export const IPAWS_EAS_AUDIO_RESOURCE_DESCRIPTION = 'EAS Broadcast Content';
// The IDG spelling of MP3 broadcast content. The server stamps this value on the resource.
export const IPAWS_EAS_AUDIO_RESOURCE_MIME_TYPE = 'audio/x-ipaws-audio-mp3';

export const getIpawsAudioFileError = (file) => {
  if (!(file instanceof File)) return 'Select an MP3 audio file.';
  if (!file.name.toLowerCase().endsWith('.mp3')) return 'Only .mp3 audio files are supported.';
  if (!['audio/mpeg', 'audio/mp3'].includes(file.type)) {
    return 'The selected file must use an MP3 audio type.';
  }
  if (file.size > IPAWS_EAS_AUDIO_MAXIMUM_BYTES) {
    return 'The MP3 file must be 4 MB or smaller.';
  }
  return '';
};

export const getIpawsAudioDuration = (file) =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const audio = new Audio();
    const cleanUp = () => {
      audio.removeAttribute('src');
      audio.load();
      URL.revokeObjectURL(objectUrl);
    };

    audio.onloadedmetadata = () => {
      const { duration } = audio;
      cleanUp();
      if (!Number.isFinite(duration)) reject(new Error('Audio duration is unavailable.'));
      else resolve(duration);
    };
    audio.onerror = () => {
      cleanUp();
      reject(new Error('The MP3 file could not be read.'));
    };
    audio.preload = 'metadata';
    audio.src = objectUrl;
  });

export const formatIpawsAudioDuration = (durationSeconds) => {
  const totalSeconds = Math.max(0, Math.round(Number(durationSeconds) || 0));
  const minutes = Math.floor(totalSeconds / 60);
  return `${minutes}:${String(totalSeconds % 60).padStart(2, '0')}`;
};
